import {getCollection, getDoc} from "@/libs/firestore";

function getActivityLogs(uid: string | undefined) {
    return getCollection(`users/${uid}/activity/${uid}/logs`);
}

function getActivityDoc(uid: string | undefined) {
    return getDoc(`users/${uid}/activity/${uid}`);
}

export {getActivityLogs, getActivityDoc};